import React from "react";

export default function Iframe(props) {
  return (
    <iframe
      src={props.src}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
      style={{
        position: "absolute",
        top: props.top ? props.top : "0",
        left: "0",
        width: "100%",
        height: props.height ? props.height : "100%",
      }}
    />
  );
}
